import styled from "styled-components";
import NovaIcon from "../../assets/images/logo/tokens/novamining.png";
import { useEffect,useRef,useState } from "react";


const CardContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    top: 0;
    left: 0;
    box-shadow: ${({rarity,inDeck}) => rarity === "Mytical" && !inDeck ? "0px 0px 15px 1px rgba(255,255,255,1)" : "none"};
    border-radius: 7.58%;
`

const CryptidImageContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 67%;
    top: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    overflow: hidden;
`
const CryptidImg = styled.img`
    position: absolute;
    width: 90%;
    bottom: -12%;
    height: 100%;
`

const CryptidCard = ({ cryptid ,inDeck}) => {
    // const [cryptidBackground, setCryptidBackground] = useState(NormalCryptidBackground);
    // const [levelBox, setLevelBox] = useState();
    // const [rarityBox, setRarityBox] = useState();
    // const [background, setBackground] = useState(NormalCryptidCardBackground);
    // const [cryptidImage, setCryptidImage] = useState(null);
    // const [typeImage, setTypeImage] = useState(null);
    // const [weaknessImage, setWeaknessImage] = useState(null);
    const [cardInfo, setCardInfo] = useState({
        levelBox:null,
        rarityBox:null,
        cryptidBackground:null,
        background:null,
        cryptidImage: null,
        typeImage: null,
        weaknessImage: null,
    });

    const [titleDesign, setTitleDesign] = useState({
        color: "white",
        stroke: "white",
        strokeWidth: "0",
    });
    const [miningPowerDesign, setMiningPowerDesign] = useState({
        color: "white",
        stroke: "white",
        strokeWidth: "0",
    });
    const [level, setLevel] = useState(0);
    const [cardId, setCardId] = useState(null);
    const miningText = useRef(null);
    const [miningTextWidth, setMiningTextWidth] = useState(0);

    useEffect(() => {
        let bgSrc= "";
        let cryptidImg = "";
        let typeImage = "";
        let weaknessImage = "";
        let colorId = "";
        let bgImage = "";
        let rareBox = "";
        let lvlBox = "";
        try {
            bgSrc = require(`../../assets/images/background/cryptids/${(cryptid.rarity.name).toLowerCase()}1.png`);
            bgImage = require(`../../assets/icons/rarityBackground/${(cryptid.rarity.name).toLowerCase()}.png`);
            rareBox = require(`../../assets/icons/rarity/${cryptid.rarity.name.toLowerCase()}.svg`);
            lvlBox = require(`../../assets/icons/rarity/${cryptid.rarity.name.toLowerCase()}_level.svg`);
            typeImage = require(`../../assets/images/types/${cryptid.type.toLowerCase()}.png`) || require(`../../assets/images/types/unknown.png`);
            weaknessImage = require(`../../assets/images/types/${cryptid.weakness.toLowerCase()}.png`) || require(`../../assets/images/types/unknown.png`);
            colorId = `url(#${cryptid.rarity.name.toLowerCase()})`;
            // cryptidImg =cryptid.name?.length ? require(`../../assets/images/cryptids/${cryptid.name.toLowerCase().replace(/\s+/g, "")}.png`) : require(`../../assets/images/cryptids/unknown.png`);
        } catch (error) {
            console.error("Error loading images", error);
        }


        switch(cryptid.rarity.name){
            case "Legend":
                setTitleDesign({
                    color: "white",
                    stroke: colorId,
                    strokeWidth: "10",
                });
                setMiningPowerDesign({
                    color: "url(#legendMiningColor)",
                    stroke: "url(#legendMiningColor)",
                    strokeWidth: "0",
                });
                break;
            case "Mytical":
                setTitleDesign({
                    color: colorId,
                    stroke: "#E997FE",
                    strokeWidth: "10",
                });
                setMiningPowerDesign({
                    color: "url(#myticalMiningColor)",
                    stroke: "url(#myticalMiningStroke)",
                    strokeWidth: "10",
                });
                break;
            default:
                break;
        }

        // setTypeImage(typeImage);
        // setWeaknessImage(weaknessImage);
        // setCryptidImage(cryptid?.imageUri || cryptidImg);
        
        setCardInfo({
            background: bgSrc,
            levelBox: lvlBox,
            rarityBox: rareBox,
            weaknessImage,
            typeImage,
            cryptidImage: cryptid?.imageUri ||  cryptidImg,
            cryptidBackground: bgImage
        })
        // setBackground(bgSrc);
        // setLevelBox(lvlBox);
        // setRarityBox(rareBox);
        // setCryptidBackground(bgImage);
    }, [cryptid?.rarity, cryptid?.name, cryptid?.type, cryptid?.weakness]);

    useEffect(() => {
        if(!cryptid.level){
            setLevel(0);
        }else{
            setLevel(cryptid.level.value);
        }
        if(cryptid?.cardId){
            setCardId(cryptid.cardId);
        }
        if (miningText.current) {
            const bbox = miningText.current.getBBox();
            setMiningTextWidth(bbox.width);
          }
    }, [cryptid?.level]);

    return (
        <CardContainer inDeck={inDeck} rarity={cryptid?.rarity?.name}>
            {/* <CryptidImageContainer>
              <CryptidImg src={cryptidImage} style={{backgroundColor:"red"}} alt="cryptid" />
            </CryptidImageContainer> */}
            
            <svg viewBox="0 0 859 1320" style={{position: "absolute", width: "100%", height: "100%"}}>
            <image width="100%" height="100%" xlinkHref={cardInfo.background} />
            <image y={180} x="5%" width="90%" xlinkHref={cardInfo.cryptidBackground} />
                <linearGradient id="mytical" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#641E72" />
                <stop offset="45%" stopColor="#AB5BBB" />
                <stop offset="100%" stopColor="#741787" />
                </linearGradient>
                <linearGradient id="legend" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#5C5101" />
                <stop offset="45%" stopColor="#E0CF61" />
                <stop offset="100%" stopColor="#5C5101" />
                </linearGradient>
                <linearGradient id="legendMiningColor" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#FFFFFF" />
                <stop offset="35%" stopColor="#FFF08C" />
                <stop offset="48.5%" stopColor="#D6C96F" />
                <stop offset="65%" stopColor="#FFFBD2" />
                <stop offset="100%" stopColor="#FFFFBD" />
                </linearGradient>
                <linearGradient id="myticalMiningColor" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#FFFFFF" />
                <stop offset="35%" stopColor="#FFF08C" />
                <stop offset="48.5%" stopColor="#A2942E" />
                <stop offset="65%" stopColor="#FFFBD2" />
                <stop offset="100%" stopColor="#FFFFBD" />
                </linearGradient>
                <linearGradient id="myticalMiningStroke" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#C0966C" />
                    <stop offset="30%" stopColor="#807468" />
                    <stop offset="48.5%" stopColor="#E7A059" />
                    <stop offset="100%" stopColor="#8C4545" />
                </linearGradient>

                <svg width="100%" y={-160} height="100%">
                    <defs>
                    <clipPath id="cut-off-bottom">
                        <rect x="0" y="50" width="100%" height="75%" />
                    </clipPath>
                    </defs>
                    <image
                        width="103%"
                        height="100%"
                        xlinkHref={cardInfo.cryptidImage}
                        clipPath="url(#cut-off-bottom)"
                    />
                </svg>
              <text
                    x={50}
                    y={115}
                    fill={titleDesign.color}
                    stroke={titleDesign.stroke}
                    strokeWidth={titleDesign.strokeWidth}
                    paintOrder="stroke"
                    fontSize="75px"
                >
                {cryptid?.name}
             </text>
                <image x="68" y="803" width="180" height="180" xlinkHref={cardInfo.levelBox} />
                <image x="640" y="810" width="170" height="170" xlinkHref={cardInfo.rarityBox} />
                <image x="714" y="1014" height="65" xlinkHref={cardInfo.weaknessImage} />
                <image x="262" y="1018" height="65" xlinkHref={cardInfo.typeImage} />
              <text
                    x={level == 1 ? 148 : 140}
                    y={896}
                    fill="white"
                    fontSize="60px"
                >
                {level}
             </text>
             {cardId &&
                        <text
                             x={448}
                             y={968}
                             fill="white"
                             fontSize="54px"
                         >
                         {cryptid.cardId}
                      </text>
             }
             <text
                    ref={miningText}
                    x={260}
                    y={1193}
                    fill={miningPowerDesign.color}
                    stroke={miningPowerDesign.stroke}
                    strokeWidth={miningPowerDesign.strokeWidth}
                    paintOrder="stroke"
                    fontSize="54px"
                >
                {cryptid.miningPower?.toFixed(2)}
             </text>
             <image x={miningTextWidth + 265} y="1130" width="85" height="85" xlinkHref={NovaIcon} />
             <text
                    x={miningTextWidth + 355}
                    y={1193}
                    fill={miningPowerDesign.color}
                    stroke={miningPowerDesign.stroke}
                    strokeWidth={miningPowerDesign.strokeWidth}
                    paintOrder="stroke"
                    fontSize="54px"
                >
                /d
             </text>
            </svg>
            {/* <CardBackground src={background} alt="cryptid card" /> */}
        </CardContainer>
    );


};

export default CryptidCard;